// extracted by mini-css-extract-plugin
export default {"addon":"InputAddon_addon__D7sWF"};